module.exports = __webpack_public_path__ + "img/vikingas.e4eab7e4.png";